import React, { useState, useEffect, Fragment } from "react";

import {
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControl,
  Autocomplete,
  LinearProgress,
  FormLabel,
} from "@mui/material";
import { Button } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import { NavLink, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material/";

import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import api from "../../api/axios";

const Crear = () => {
  const navigate = useNavigate();

  const { goPanel, goTable } = useLocationHelpers();
  const Swal = require("sweetalert2");
  const [flagCompanySelected, setFlagCompanySelected] = useState(true);

  // Estados para abrir las opciones y sus datos
  const [openOptions, setOpenOptions] = useState({
    userRol: false,
    company: false,
    // offices: false,
    provinces: false,
    asociations: false,
    zones: false,
    status: false,
  });

  const [options, setOptions] = useState({
    userRol: [],
    company: [],
    // offices: [],
    provinces: [],
    asociations: [],
    zones: [],
    status: [],
  });

  // Loading Options
  const loadingOptions = Object.fromEntries(
    Object.entries(openOptions).map(([key, value]) => [
      key,
      value && (options[key] ? options[key].length === 0 : true),
    ]),
  );

  // Toma de valores
  const [formValues, setFormValues] = useState({
    userRolId: "",
    companyId: "",
    // officesId: "",
    userEmail: "",
    userName: "",
    userSurname: "",
    userAddress: "",
    userPostalCode: "",
    userDocument: "",
    userPhone: "",
    provinceName: "",
    asociationId: "",
    zonesId: "",
    userTasks: "",
    valCaseTypeForm: "",
  });

  const [flag, setFlag] = useState(false);

  // GET DATA LIST
  const getDataList = async (actualUrl) => {
    setFlag(true);
    const url = `${actualUrl}/createlawyer`;

    try {
      const response = await api.post(url);

      const { provinces, companies, zones, roles } = response.data;

      const defaultOptions = { id: 0 };
      setOptions({
        userRol: [{ type: "Seleccionar", ...defaultOptions }, ...roles],
        company: [
          { company_name: "Seleccionar", ...defaultOptions },
          ...companies,
        ],
        status: [
          { nombre: "Ninguno", id: 0 },
          { nombre: "Abogado", id: 1 },
          { nombre: "Perito", id: 2 },
        ],
        provinces: [
          { provincia: "Seleccionar", ...defaultOptions },
          ...provinces,
        ],
        zones: [{ zona: "Seleccionar", ...defaultOptions }, ...zones],
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o éxito
    }
  };

  // Form submit handler
  const handleClientsFormInformation = async () => {
    const isValid = validateFields();

    if (isValid) {
      const formData = new FormData();

      formData.append("type", formValues.userRolId);
      formData.append("company_id", formValues.companyId);
      formData.append("lawyer", null);
      // formData.append("office_id", formValues.officesId);
      formData.append("email", formValues.userEmail);
      formData.append("name", formValues.userName);
      formData.append("surname", formValues.userSurname);
      formData.append("address", formValues.userAddress);
      formData.append("postalcode", formValues.userPostalCode);
      formData.append("nif", formValues.userDocument);
      formData.append("phone", formValues.userPhone);
      formData.append("province", formValues.provinceName);
      formData.append("contact_id", null);
      formData.append("asociation", formValues.asociationId);
      formData.append("zone", formValues.zonesId);
      formData.append("status", 1);
      formData.append("is_lawyer", formValues.userTasks);
      formData.append("notas", formValues.valCaseTypeForm);
      formData.append("marketing", 0);

      const queryUrl = `${process.env.REACT_APP_API_URL}/storelawyer`;

      Swal.fire({
        title: "¿Desea guardar los cambios?",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Volver`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await api.post(queryUrl, formData);

            console.log(response);

            if (response.data.error) {
              if (response.data.error.errorInfo[2].includes("email")) {
                Swal.fire({
                  title: "¡Correo existente!",
                  icon: "error",
                  text: "Por favor intentelo nuevamente",
                  confirmButtonColor: "#1ab394",
                });
              } else {
                Swal.fire({
                  title: "¡No se guardaron los cambios!",
                  icon: "error",
                  text: "Por favor intentelo nuevamente",
                  confirmButtonColor: "#1ab394",
                });
              }
            } else {
              Swal.fire({
                title: "¡Guardado!",
                icon: "success",
                html: `¿Seguir creando?`,
                showDenyButton: true,
                confirmButtonColor: "#1ab394",
                cancelButtonColor: "#d33",
                reverseButtons: true,
              }).then((result) => {
                if (result.isDenied) {
                  navigate("/empresas");
                }
              });
            }
          } catch (error) {
            console.log(error);
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      });
    } else {
      showValidationErrors();
    }
  };

  // Validate required fields
  const validateFields = () => {
    const fields = [
      { value: formValues.userName, name: "Nombre" },
      { value: formValues.userDocument, name: "Documento" },
      { value: formValues.userAddress, name: "Dirección" },
      { value: formValues.provinceName, name: "Provincia" },
      { value: formValues.userPostalCode, name: "Código postal" },
      { value: formValues.userEmail, name: "Email" },
      { value: formValues.userPhone, name: "Teléfono" },
    ];

    return fields.every((field) => field.value !== "" && field.value !== null);
  };

  const showValidationErrors = () => {
    const fields = [
      { value: formValues.userName, name: "Nombre" },
      { value: formValues.userDocument, name: "Documento" },
      { value: formValues.userAddress, name: "Dirección" },
      { value: formValues.provinceName, name: "Provincia" },
      { value: formValues.userPostalCode, name: "Código postal" },
      { value: formValues.userEmail, name: "Email" },
      { value: formValues.userPhone, name: "Teléfono" },
    ];

    const missingFields = fields
      .filter((field) => field.value === "" || field.value === null)
      .map((field) => `<li>${field.name}</li>`)
      .join("");

    Swal.fire({
      title: "¡Error!",
      icon: "error",
      html: `<div style="text-align: start;">Por favor rellene los campos: <ul>${missingFields}</ul></div>`,
      confirmButtonColor: "#1ab394",
    });
  };

  // SET VARIABLES
  useEffect(() => {
    getDataList(process.env.REACT_APP_API_URL);
  }, []);

  useEffect(() => {
    const loadOptions = (key) => {
      if (loadingOptions[key]) {
        setTimeout(() => {
          // Aquí deberías obtener los datos de options de alguna fuente externa si es necesario
          setOptions((prevOptions) => ({
            ...prevOptions,
            [key]: options[key], // Asumiendo que tienes los datos cargados en options[key]
          }));
        }, 1000); // Tiempo de espera para simular carga
      }
    };

    Object.keys(openOptions).forEach(loadOptions);
  }, [loadingOptions, openOptions]);

  const fieldsConfig = [
    {
      type: "autocomplete",
      id: "userRolId",
      label: "Tipo de usuario",
      onChange: (value) => {
        setFormValues((prev) => ({
          ...prev,
          userRolId: value ? value.id : null,
        }));
      },
      open: openOptions.userRol,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, userRol: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, userRol: false })),
      options: options.userRol,
      loading: loadingOptions.userRol,
      getOptionLabel: (option) => option.type,
      show: true,
    },
    {
      type: "autocomplete",
      id: "companyId",
      label: "Empresa",
      onChange: (value) => {
        setFormValues((prev) => ({
          ...prev,
          companyId: value ? value.id : null,
        }));
        filterDataByCompany(value ? value.id : 0);
      },
      open: openOptions.company,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, company: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, company: false })),
      options: options.company || [], // Asigna un arreglo vacío si options.company es undefined
      loading: loadingOptions.company,
      getOptionLabel: (option) => option.company_name,
      show: true,
    },
    // {
    //   type: "autocomplete",
    //   id: "officesId",
    //   label: "Despachos",
    //   onChange: (value) =>
    //     setFormValues((prev) => ({
    //       ...prev,
    //       officesId: value ? value.id : null,
    //     })),
    //   open: openOptions.offices,
    //   onOpen: () => setOpenOptions((prev) => ({ ...prev, offices: true })),
    //   onClose: () => setOpenOptions((prev) => ({ ...prev, offices: false })),
    //   options: options.offices,
    //   loading: loadingOptions.offices,
    //   getOptionLabel: (option) => option.office_name,
    //   show: true,
    //   disabled: flagCompanySelected,
    // },
    {
      type: "autocomplete",
      id: "provinceName",
      label: "Provincia",
      onChange: (value) =>
        setFormValues((prev) => ({
          ...prev,
          provinceName: value ? value.provincia : null,
        })),
      open: openOptions.provinces,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, provinces: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, provinces: false })),
      options: options.provinces,
      loading: loadingOptions.provinces,
      getOptionLabel: (option) => option.provincia,
      show: true,
    },
    {
      type: "autocomplete",
      id: "asociationId",
      label: "Asociación",
      onChange: (value) =>
        setFormValues((prev) => ({
          ...prev,
          asociationId: value ? value.id : null,
        })),
      open: openOptions.asociations,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, asociations: true })),
      onClose: () =>
        setOpenOptions((prev) => ({ ...prev, asociations: false })),
      options: options.asociations,
      loading: loadingOptions.asociations,
      getOptionLabel: (option) => option.asoc_name,
      show: true,
      disabled: flagCompanySelected,
    },
    {
      type: "autocomplete",
      id: "userTasks",
      label: "Tareas de",
      onChange: (value) =>
        setFormValues((prev) => ({ ...prev, userTasks: value.id })),
      open: openOptions.status,
      onOpen: () => setOpenOptions((prev) => ({ ...prev, status: true })),
      onClose: () => setOpenOptions((prev) => ({ ...prev, status: false })),
      options: options.status,
      loading: loadingOptions.status,
      getOptionLabel: (option) => option.nombre,
      show: true,
    },
    {
      type: "text",
      id: "userEmail",
      label: "Email",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userEmail: e.target.value })),
      show: true,
    },
    {
      type: "text",
      id: "userName",
      label: "Nombre",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userName: e.target.value })),
      show: true,
    },
    {
      type: "text",
      id: "userSurname",
      label: "Apellido",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userSurname: e.target.value })),
      show: true,
    },
    {
      type: "text",
      id: "userAddress",
      label: "Dirección",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userAddress: e.target.value })),
      show: true,
    },
    {
      type: "text",
      id: "userPostalCode",
      label: "Código Postal",
      onChange: (e) =>
        setFormValues((prev) => ({
          ...prev,
          userPostalCode: e.target.value,
        })),
      show: true,
    },
    {
      type: "text",
      id: "userDocument",
      label: "NIF/Pasaporte",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userDocument: e.target.value })),
      show: true,
    },
    {
      type: "text",
      id: "userPhone",
      label: "Teléfono",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, userPhone: e.target.value })),
      show: true,
    },
    {
      type: "textarea",
      id: "valCaseTypeForm",
      label: "Notas",
      onChange: (e) =>
        setFormValues((prev) => ({ ...prev, valCaseTypeForm: e.target.value })),
      show: true,
    },
  ];

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = async (company_id) => {
    console.log(company_id);
    if (company_id) {
      try {
        let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

        const response = await api.post(queryUrl, { company: company_id });

        if (response) {
          const {
            //  offices,
            associations,
          } = response.data;

          const defaultOptions = { id: 0 };

          setOptions((prevOptions) => ({
            ...prevOptions, // Mantiene las opciones anteriores
            // offices: [{ office_name: "Seleccionar", id: 0 }, ...offices],
            asociations: [{ asoc_name: "Seleccionar", id: 0 }, ...associations],
          }));

          setFlagCompanySelected(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setFlagCompanySelected(true);
    }
  };

  //////////////////// FILTER BY COMPANY  ///////////////////////
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Usuarios" subTitle="Crear" />

      {flag && <LinearProgress color="success" />}
      {!flag && (
        <Box
          component="form"
          sx={{ margin: "auto", "& > :not(style)": {} }}
          noValidate
          autoComplete="off"
          className="formMainContainer">
          <Grid
            container
            style={{ textAlign: "center" }}
            className="fontSize"
            p={2}>
            {fieldsConfig.map(
              (field) =>
                field.show && (
                  <Fragment key={field.id}>
                    {" "}
                    {/* Añade el key aquí */}
                    {field.type === "autocomplete" ? (
                      <Grid item xs={6} sx={{ padding: "5px" }}>
                        <Autocomplete
                          options={field.options || []} // Asegúrate de que sea un array
                          loading={field.loading}
                          open={field.open}
                          onOpen={field.onOpen}
                          disabled={field.disabled}
                          onClose={field.onClose}
                          onChange={(event, value) => field.onChange(value)}
                          getOptionLabel={field.getOptionLabel}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <Fragment>
                                    {params.InputProps.endAdornment}
                                  </Fragment>
                                ),
                                form: {
                                  autoComplete: "off", // Desactiva las sugerencias del navegador en el formulario
                                },
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // Truco para evitar que los navegadores activen el autofill
                              }}
                            />
                          )}
                        />
                      </Grid>
                    ) : field.type === "text" ? (
                      <Grid item xs={6} sx={{ padding: "5px" }} key={field.id}>
                        <TextField
                          label={field.label}
                          onChange={field.onChange}
                          variant="outlined"
                          autoComplete="new-password" // Desactiva el autofill general
                          fullWidth
                          size="small"
                          inputProps={{
                            maxLength:
                              field.id === "userPostalCode" ? 10 : undefined,
                          }}
                        />
                      </Grid>
                    ) : field.type === "textarea" ? (
                      <Grid item xs={12} sx={{ padding: "5px" }} key={field.id}>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel sx={{ textAlign: "left" }}>
                            Observaciones
                          </FormLabel>
                          <textarea
                            style={{
                              height: "100px",
                              resize: "none",
                              padding: "6px 13px",
                              fontSize: "15px",
                              borderRadius: "4px",
                              border: "1px solid rgba(128, 128, 128, 0.35)",
                            }}
                            onChange={field.onChange} // Asignar la función onChange
                          />
                        </FormControl>
                      </Grid>
                    ) : null}
                  </Fragment>
                ),
            )}
          </Grid>
          <Grid container p={2}>
            <ButtonGroup
              sx={{
                width: "100%",
              }}>
              <Button
                onClick={handleClientsFormInformation}
                variant="outlined"
                color="success"
                size="small"
                sx={{
                  padding: "5px !important",
                  color: "#2e7d32 !important",
                  fontWeight: "700",
                  width: "100%",
                }}>
                Guardar
              </Button>
              <Button
                onClick={() => goTable("usuarios", "Usuarios")}
                variant="outlined"
                color="error"
                size="small"
                sx={{
                  padding: "5px !important",
                  color: "#d32f2f !important",
                  fontWeight: "700",
                  width: "100%",
                }}>
                Tabla
              </Button>
              <Button
                onClick={goPanel}
                variant="outlined"
                size="small"
                sx={{
                  padding: "5px !important",
                  color: "#1976d2 !important",
                  fontWeight: "700",
                  width: "100%",
                }}>
                Inicio
              </Button>
            </ButtonGroup>
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default Crear;
